import { connect } from 'react-redux';
import compose from 'recompose/compose';
import SelectedElementAssets from '../../../components/handoff/sidebar/SelectedElementAssets';
import onlyIf from '../../../hocs/onlyIf';
import * as handoff from '../../../selectors/handoff';
import { hasAssets } from '../../../utils/handoff/element';
function mapStateToProps(state) {
    var element = handoff.getSelectedElement(state);
    if (!element) {
        return {};
    }
    if (!hasAssets(element)) {
        return {};
    }
    return {
        element: element,
    };
}
export default compose(connect(mapStateToProps), onlyIf(function (props) { return props.element; }))(SelectedElementAssets);
